/**************************************************
 * Nombre:       Formulario_Reserva_Check_Out
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Divider, Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {
    BadgeOutlined,
    BedroomParentOutlined,
    PointOfSaleOutlined,
    PriceCheckOutlined,
    RequestQuoteOutlined
} from "@mui/icons-material";
import IngresoFecha from "../../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import {useEffect, useState} from "react";
import {formatoMoneda} from "../../../Utilidades/formatoMoneda";
import Valores_Reservas from "../../Componentes/Valores_Reservas";

const Formulario_Reserva_Check_Out = ({...props}) => {






    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={BedroomParentOutlined} nombre={'# Habitacion'} dato={'numero'}
                                  editable={false} {...props} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoFecha Icono={PointOfSaleOutlined} nombre={'Fecha de Salida'} dato={'fechaSalida'}
                                  editable={false} {...props} />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{m: 2}}>
                    <Divider sx={{width: '100%'}}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Valores_Reservas props={props}/>
                </Grid>




                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Notas Internas'} dato={'notas'} {...props}
                                  lineas={6}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Reserva_Check_Out